var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    alt: "Shopping Cart Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.29,11.14a1.61,1.61,0,0,0-1.1-.5H11.79L11.49,9a1.4,1.4,0,0,0-1.4-1.2H6.89a1.4,1.4,0,1,0,0,2.8h2l2.6,15.7c0,.1,0,.1.1.2s0,.1.1.2.1.2.2.3.1.1.1.2.2.1.3.2.1.1.2.1a.9.9,0,0,0,.5.1h15.4a1.4,1.4,0,0,0,0-2.8H14.09l-.2-1.4h15.9a1.4,1.4,0,0,0,1.4-1.2l1.4-9.8A1.69,1.69,0,0,0,32.29,11.14Zm-2.7,2.3-.4,2.8h-5v-2.8Zm-6.8,0v2.8h-4.2v-2.8Zm0,4.2v2.8h-4.2v-2.8Zm-5.6-4.2v2.8h-4.4l-.5-2.9h4.9ZM13,17.64h4.2v2.8h-3.7Zm11.2,2.8v-2.8H29l-.4,2.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.09,
    cy: 30.94,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.69,
    cy: 30.94,
    r: 2.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/ShoppingCart.69c5c3ac.svg";
export { ForwardRef as ReactComponent };